module.exports = __webpack_public_path__ + "static/media/favicon.e1a83a13.png";